export default __webpack_public_path__ + "static/media/IMG_5001-min.764150b7.JPG";